// Cliente HTTP da Etapa 3. As etapas anteriores não foram alteradas.
import { configureFolhaApi as configureEtapas1e2 } from '../etapa2/api'

let config = {
  baseUrl: '/api/v1' /* URL definida por configureFolhaApiEtapa6 (integração FSC) */,
  getHeaders: async () => ({}),
}

export function configureApiEtapa3({ baseUrl, getHeaders } = {}) {
  config = { baseUrl: baseUrl ?? config.baseUrl, getHeaders: getHeaders ?? config.getHeaders }
}

// Configura os clientes das Etapas 1, 2 e 3 de uma vez.
export function configureFolhaApiCompleta(opcoes = {}) {
  configureEtapas1e2(opcoes)
  configureApiEtapa3(opcoes)
}

async function request(method, path, body, contentType = 'application/json') {
  const headers = { 'Content-Type': contentType, ...(await config.getHeaders()) }
  const resp = await fetch(`${config.baseUrl}${path}`, {
    method,
    headers,
    body: body === undefined ? undefined : contentType === 'application/json' ? JSON.stringify(body) : body,
  })
  const data = await resp.json().catch(() => null)
  if (!resp.ok) {
    const detail = data?.detail
    const msg = Array.isArray(detail)
      ? detail.map((d) => `${d.loc?.slice(-1)[0] ?? ''}: ${d.msg}`).join('; ')
      : typeof detail === 'object' && detail ? detail.mensagem || JSON.stringify(detail) : detail || resp.statusText
    throw new Error(msg)
  }
  return data
}

const enc = encodeURIComponent

export const apiEtapa3 = {
  // Benefícios
  valeTransporte: (e) => request('POST', '/beneficios/vale-transporte/calcular', e),
  alimentacao: (e) => request('POST', '/beneficios/alimentacao/calcular', e),
  // Planos
  operadoras: () => request('GET', '/beneficios/planos/operadoras'),
  criarOperadora: (d) => request('POST', '/beneficios/planos/operadoras', d),
  tabelas: () => request('GET', '/beneficios/planos/tabelas'),
  criarTabela: (d) => request('POST', '/beneficios/planos/tabelas', d),
  adesoes: (empresaId) => request('GET', `/beneficios/planos/adesoes?empresa_id=${enc(empresaId)}`),
  criarAdesao: (d) => request('POST', '/beneficios/planos/adesoes', d),
  mensalidades: (empresaId, competencia) => request('GET', `/beneficios/planos/mensalidades/${enc(empresaId)}/${competencia}`),
  importarCoparticipacao: (empresaId, operadoraId, competencia, arquivo) =>
    request('POST', `/beneficios/planos/coparticipacao/importar?empresa_id=${enc(empresaId)}&operadora_id=${enc(operadoraId)}&competencia=${competencia}`, arquivo, 'text/csv'),
  // eSocial
  cadastro: (empresaId) => request('GET', `/esocial/empresas/${enc(empresaId)}/cadastro`),
  salvarCadastro: (empresaId, d) => request('PUT', `/esocial/empresas/${enc(empresaId)}/cadastro`, d),
  validarS1005: (empresaId) => request('GET', `/esocial/s1005/${enc(empresaId)}/validar`),
  validarS1020: (empresaId) => request('GET', `/esocial/s1020/${enc(empresaId)}/validar`),
  validarS1200: (lote) => request('POST', '/esocial/s1200/validar', lote),
  gerarS1210: (e) => request('POST', '/esocial/s1210/gerar', e),
  painel: (empresaId) => request('GET', `/esocial/painel/alertas?empresa_id=${enc(empresaId)}`),
  marcarEnviado: (eventoId) => request('POST', `/esocial/eventos/${eventoId}/marcar-enviado`),
  // Automação
  consultarFap: (cnpj) => request('GET', `/automacao/consultar-fap/${cnpj}`),
  sincronizacoes: () => request('GET', '/automacao/sincronizacoes'),
}
